import { animate, style, transition, trigger } from '@angular/animations';

export const sdPlanPanelExpand = trigger('sdPlanPanelExpand', [
  transition(':enter', [
    style({ height: 0, opacity: 0, overflow: 'hidden' }),
    animate(
      '480ms cubic-bezier(0.22, 1, 0.36, 1)',
      style({ height: '*', opacity: 1, overflow: 'hidden' })
    )
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate(
      '360ms cubic-bezier(0.4, 0, 0.2, 1)',
      style({ height: 0, opacity: 0, overflow: 'hidden' })
    )
  ])
]);
